export function yesNo(bool:boolean|number = false):string {
    return bool === true || bool === 1 ? 'Yes' : 'No';
}
